import { render } from "./CompetitionExtraInfo.vue?vue&type=template&id=652f539a&scoped=true"
import script from "./CompetitionExtraInfo.vue?vue&type=script&lang=js"
export * from "./CompetitionExtraInfo.vue?vue&type=script&lang=js"

import "./CompetitionExtraInfo.vue?vue&type=style&index=0&id=652f539a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f539a"]])

export default __exports__